@if (itemsWithJsonData.length) {
    <app-table
        [items]="itemsWithJsonData"
        [columns]="columns"
        translatePrefix="form.ni."
        [hideCheckboxes]="true"
        [resource]="resource"
        (detailCallback)="detail($event)"
        (deleteCallbackWithEvent)="delete($event)"
    >
        <ng-template pTemplate="printHeader"></ng-template>
        <ng-template pTemplate="print" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-print"
                (clickEvent)="print(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copyHeader"></ng-template>
        <ng-template pTemplate="copy" let-item="item">
            <app-button
                [text]="true"
                styleClass="p-button-set-icon-size"
                icon="pi-copy"
                (clickEvent)="copy(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="nightCalm" let-item="item">
            <span
                [pTooltip]="('form.ni.nightCalmOptions.' + item.data.nightCalm) | translate"
            >{{ item.data.nightCalm }}</span>
        </ng-template>

        <ng-template pTemplate="communication" let-item="item">
            <span
                [pTooltip]="('form.ni.communicationOptions.' + item.data.communication) | translate"
            >{{ item.data.communication }}</span>
        </ng-template>

        <ng-template pTemplate="memory" let-item="item">
            <span
                [pTooltip]="('form.ni.memoryOptions.' + item.data.memory) | translate"
            >{{ item.data.memory }}</span>
        </ng-template>

        <ng-template pTemplate="contact" let-item="item">
            <span
                [pTooltip]="('form.ni.contactOptions.' + item.data.contact) | translate"
            >{{ item.data.contact }}</span>
        </ng-template>

        <ng-template pTemplate="behavior" let-item="item">
            <span
                [pTooltip]="('form.ni.behaviorOptions.' + item.data.behavior) | translate"
            >{{ item.data.behavior }}</span>
        </ng-template>

        <ng-template pTemplate="emotions" let-item="item">
            <span
                [pTooltip]="('form.ni.emotionsOptions.' + item.data.emotions) | translate"
            >{{ item.data.emotions }}</span>
        </ng-template>

        <ng-template pTemplate="consciousness" let-item="item">
            <span
                [pTooltip]="('form.ni.consciousnessOptions.' + item.data.consciousness) | translate"
            >{{ item.data.consciousness }}</span>
        </ng-template>

        <ng-template pTemplate="problemSolving" let-item="item">
            <span
                [pTooltip]="('form.ni.problemSolvingOptions.' + item.data.problemSolving) | translate"
            >{{ item.data.problemSolving }}</span>
        </ng-template>

        <ng-template pTemplate="orientation" let-item="item">
            <span
                [pTooltip]="('form.ni.orientationOptions.' + item.data.orientation) | translate"
            >{{ item.data.orientation }}</span>
        </ng-template>

        <ng-template pTemplate="perception" let-item="item">
            <span
                [pTooltip]="('form.ni.perceptionOptions.' + item.data.perception) | translate"
            >{{ item.data.perception }}</span>
        </ng-template>

    </app-table>
}
